module.exports = __webpack_public_path__ + "static/media/img-1.1a869b98.jpg";